// extracted by mini-css-extract-plugin
export default {"zoomModal":"o4-z"};